export { default } from './CercadorMunicipi';
